// Module
var code = "<iframe style=\"min-width:100%;height:600px\" data-bind=\"iframeContent: $data._value\"></iframe>";
// Exports
export default code;